import { registerPlugin } from '@capacitor/core';

export interface ICanMakePaymentsArgs {
  allowedPaymentMethods: string;
  networks: string[];
  environment: string;
}

export interface IGooglePayPlugin {
  canMakePayments(args: ICanMakePaymentsArgs): Promise<{ available: boolean; hasCards: boolean }>;
  makePaymentRequest(params: {
    allowedPaymentMethods: string;
    countryCode: string;
    currencyCode: string;
    total: string;
    payeeName: string;
    itemLabel: string;
    gateway: string;
    gatewayMerchantId: string;
  }): Promise<any>;
}

export const GooglePayPlugin = registerPlugin<IGooglePayPlugin>('GooglePayPlugin');
